import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return (
    data?.map((item: any, index: any) => {
      return {
        approvalStatus: item?.approvalStatus,
        approvalType: item?.approvalType,
        className: item?.className,
        id: item?.id,
        key: item?.key,
        type: item?.type,
        username: item?.username,
        data: {
          type: 'package2Instrument',
          id: item?.object?.id,
          packageName: item?.object?.packageName,
          instrument: item?.object?.instrument,
          fileName: item?.object?.fileName,
          isGenerated: item?.object?.isGenerated,
        },
      }
    }) ?? []
  )
}

const getPackageToInstrumentPendingApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPack2InstPendingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getPackageToInstrumentPendingApprovals }
